import { Row, Space, Button, Modal, Col, List, Avatar } from 'antd';
import React, { useEffect, useState } from 'react';
import { getBranchOfficeVState, getState, newBranchOfficeVState } from '../../api/api';
import type { ColumnsType } from 'antd/es/table';
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from '../../services/toast.notification';
import { FormProps } from '../../utility/types';
import Spinner from '../../components/_common/Spinner';
import FormContainer from '../../components/FormContainer/FormContainer';
import CustomSelect from '../../components/_common/CustomSelect';
import { useForm } from '../../utility/useForm';
import { NoValidateForm } from '../../utility/validationRules';
import { EditFilled, DeleteFilled, UserOutlined } from "@ant-design/icons";

export const AssignStateDialog: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {
    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(NoValidateForm) as any
    const [isLoading, setIsLoading] = useState(true);
    const [permission, setPermission] = useState(false);
    const [states, setStates] = useState([]);
    const [parsicStateList, setParsicStateList] = useState();
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [selectedStateId, setSelectedStateId] = useState<number | null>(null);

    useEffect(() => {
        if (visible) {
            loadBranchOfficeVStates();
        }
    }, [visible]);

    const loadBranchOfficeVStates = () => {

        getBranchOfficeVState(payLoad.branchOfficeId)
            .then((result: any) => {
                setStates(result.data.data)
                //setIsLoading(false);
                loadParsicStates();
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }
    const loadParsicStates = () => {

        getState()
            .then((result: any) => {
                setParsicStateList(result.data.data)
                setIsLoading(false);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

    }
    const onSubmitForm = (e: any) => {
        e.preventDefault();

        setIsSubmiting(true)
        var model = {
            "mode": payLoad.mode,
            "branchOfficeId": payLoad.branchOfficeId,
            "branchOfficeVUserId": 0,
            "branchOfficeVStateId": 0,
            "stateId": values.parsicState,
            "userId": 0,
            "branchName": "",
            "branchDesc": ""
        }
        newBranchOfficeVState(model).then((result: any) => {
            sucessNotify("اطلاعات با موفقیت ثبت شد", undefined, 5000)
            onCancel();
            setIsSubmiting(false)
        })
            .catch((error) => {
                console.log(error);
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const deleteOfficeVStateOnClick = (id: number) => {
        Modal.confirm({
          title: "حذف استان",
          content: "آیا از حذف این استان مطمئن هستید؟",
          okText: "بله، حذف شود",
          cancelText: "انصراف",
          okType: "danger",
          direction: "rtl",

          okButtonProps: {
            style: { marginLeft: 0 },
          },
        
          cancelButtonProps: {
            style: { marginLeft: 0 },
          },
      
          onOk: () => {
            const model = {
              mode: 2,
              branchOfficeId: 0,
              branchOfficeVUserId: 0,
              branchOfficeVStateId: payLoad.branchOfficeId,
              stateId: id,
              userId: 0,
              branchName: "",
              branchDesc: "",
            };
      
            return newBranchOfficeVState(model)
              .then(() => {
                sucessNotify("استان با موفقیت حذف شد", undefined, 5000);
                loadBranchOfficeVStates(); // بهتر از بستن modal
              })
              .catch((error) => {
                errorNotify(error.response.data.errorMessage, undefined, 5000);
              });
          },
        });
      };

    const editOfficeVStateOnClick = (id: number) => {
        setSelectedStateId(id);
        setEditModalVisible(true);
    };
    const submitEdit = () => {
        const model = {
            mode: 1,
            branchOfficeId: payLoad.branchOfficeId,
            branchOfficeVStateId: selectedStateId,
            stateId: values.editState,
            userId: 0,
        };

        newBranchOfficeVState(model)
            .then(() => {
                sucessNotify("ویرایش با موفقیت انجام شد", undefined, 5000);
                setEditModalVisible(false);
                loadBranchOfficeVStates();
            })
            .catch((error) => {
                errorNotify(error.response.data.errorMessage, undefined, 5000);
            });
    };


    return (
        <>
            <Modal
                visible={visible}
                onCancel={onCancel}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
                
            >
                <>
                    {isLoading === true && (
                        <Spinner />
                    )}
                    {isLoading === false && (

                        <FormContainer title="انتصاب استان" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                           {states.length>0 &&  <Row>
                                <Col span={24}>
                                    <List
                                        dataSource={states}
                                        bordered
                                        renderItem={(item: any) => (
                                            <List.Item>
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        direction: "ltr",
                                                    }}
                                                >
                                                    <Space size="small">
                                                        <Button
                                                            onClick={() => editOfficeVStateOnClick(item.prk_BranchOfficeVStateAutoID)}
                                                            type="text"
                                                            icon={<EditFilled style={{ color: "#1677ff", fontSize: 16 }} />}
                                                            style={{ borderRadius: 6 }}
                                                        />

                                                        <Button
                                                            onClick={() => deleteOfficeVStateOnClick(item.prk_BranchOfficeVStateAutoID)}
                                                            type="text"
                                                            icon={<DeleteFilled style={{ color: "#ff4d4f", fontSize: 16 }} />}
                                                            style={{ borderRadius: 6 }}
                                                        />
                                                    </Space>

                                                    <Space style={{ direction: "rtl" }}>
                                                        <Avatar icon={<UserOutlined />} />
                                                        {item.str_StateName}
                                                    </Space>
                                                </div>
                                            </List.Item>
                                        )}
                                    />
                                </Col>
                            </Row>
}
                            <Row>
                                <Col lg={24} md={24} sm={24} xs={24}>
                                    <CustomSelect
                                        name="parsicState"
                                        placeholder="استان"
                                        itemList={parsicStateList}
                                        value={values.parsicState || ""}
                                        onChange={handleChange}
                                        valueObjectField={"prk_State_AutoID"}
                                        displayObjectField={"str_StateName"}
                                    />
                                </Col>
                            </Row>

                        </FormContainer>

                    )}
                </>

            </Modal>

            <Modal
                open={editModalVisible}
                onCancel={() => setEditModalVisible(false)}
                onOk={() => submitEdit()}
                okText="ویرایش"
                cancelText="انصراف"
            >
                <CustomSelect
                    name="editState"
                    placeholder="انتخاب استان جدید"
                    itemList={parsicStateList}
                    value={values.editState || ""}
                    onChange={handleChange}
                    valueObjectField={"prk_State_AutoID"}
                    displayObjectField={"str_StateName"}
                />
            </Modal>

        </>
    )
};

